import { render, staticRenderFns } from "./HandleAttachments.vue?vue&type=template&id=4e77fdcc"
import script from "./HandleAttachments.vue?vue&type=script&lang=js"
export * from "./HandleAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports